export default (state) => state['sportsbook/overview'].sorting;
